import React from 'react';
import classnames from 'classnames';

import WpIcon from '../icon/WpIcon';

import './WpLabel.scss';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from '../tooltip';

export interface Props {
  /** Label content */
  children?: string;
  /** A unique identifier for the label */
  id: string;
  /** Visually hide the label */
  hidden?: boolean;
  /** show required indicator */
  showRequiredIndicator?: boolean;
  labelIcon?: string;
  labelTooltipText?: string;
}

const WpLabel = ({
  children,
  id,
  labelIcon,
  labelTooltipText,
  hidden = false,
  showRequiredIndicator = false,
}: Props) => {
  const baseClassName = 'WpLabel';
  const classes = classnames(baseClassName, hidden ? `${baseClassName}--hidden` : false);

  return (
    <label id={`${id}Label`} htmlFor={id} className={classes}>
      {children}
      {showRequiredIndicator && <span className={`${baseClassName}__required-indicator`}>*</span>}
      {labelIcon && (
        <WpTooltip>
          <WpTooltipTrigger>
            <span className={`${baseClassName}__icon`}>
              <WpIcon name={labelIcon} />
            </span>
          </WpTooltipTrigger>
          {labelTooltipText && <WpTooltipContent>{labelTooltipText}</WpTooltipContent>}
        </WpTooltip>
      )}
    </label>
  );
};

export default WpLabel;
